module.exports = __webpack_public_path__ + "static/img/activity_sdy_01-4.50f7939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_01-4.jpg
// module id = Sxzm
// module chunks = 0